import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeLieu } from '../models/TypeLieu';
@Component({
  selector: 'app-type-lieu',
  templateUrl: './type-lieu.component.html'
})
export class TypeLieuComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeLieu'
  @Input() parentForm: FormGroup;
  	@Input() lieuExecution : TypeLieu;

  constructor() { }

  public ngOnInit() {
  }








  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }


}

